import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

function Franchise() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)

    const [createModal, setCreateModal] = useState(false)
    const [updateModal, setUpdateModal] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [clickData, setClickData] = useState([])
    const [reload, setReload] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setReload(e => !e)
    }

    // 검색조건 포맷
    const select3 = ["대리점명", "대리점아이디"]

    const [selectedValue2, setSelectedValue2] = useState("대리점명");

    const handleSelectChange2 = (event) => {
        const value = event.target.value;
        setSelectedValue2(value);
    };

    // 검색어 포맷
    const [selectedText4, setSelectText4] = useState("")

    const handleSelectTextChange4 = (event) => {
        const value = event.target.value;
        setSelectText4(value);
    };

    useEffect(() => {
        dispatch(change_Current_Location("대리점"))
        dispatch(changeHeaderTitle({
            mainTitle: "에이전트관리",
            subTitle: "대리점"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChange = (event) => {
        setPage(1)
        setMaxFirstPage(Number(event.target.value));
    };

    useEffect(() => {
        setPage(1)
        ListData()
    }, [reload])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/agent", {
            withCredentials: true,
            params: {
                level: 3
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data?.agent ?? [])
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "NO", "width": "50px", "textAlign": "center" },
        { "no": 2, "text": "대리점명", "width": "150px", "textAlign": "center" },
        { "no": 13, "text": "상위총판명", "width": "150px", "textAlign": "center" },
        { "no": 3, "text": "ID", "width": "100px", "textAlign": "center" },
        { "no": 4, "text": "수수료", "width": "70px", "textAlign": "center" },
        { "no": 5, "text": "정산은행", "width": "100px", "textAlign": "center" },
        { "no": 6, "text": "계좌번호", "width": "150px", "textAlign": "center" },
        { "no": 7, "text": "예금주명", "width": "120px", "textAlign": "center" },
        { "no": 8, "text": "세금계산서이메일", "width": "150px", "textAlign": "center" },
        { "no": 9, "text": "등록일자", "width": "130px", "textAlign": "center" },
        { "no": 10, "text": "변경일자", "width": "130px", "textAlign": "center" },
        // { "no": 11, "text": "작업자", "width": "70px", "textAlign": "center" },
        ...(MyData?.role === "SUPER"
            ? [{ "no": 12, "text": "수정", "width": "70px", "textAlign": "center" }]
            : [])
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let filter = [];
            if (selectedValue2 === "대리점명" && selectedText4.length > 0) {
                filter = listData.filter((p) => {
                    if (p.agent_name) return p.agent_name.toString().includes(selectedText4);
                });
            } else if (selectedValue2 === "대리점아이디" && selectedText4.length > 0) {
                filter = listData.filter((p) => {
                    if (p.agent_id) return p.agent_id.toString().includes(selectedText4);
                });
            } else {
                filter = listData;
            }

            setCombineList(filter)

            let list = filter?.slice((page - 1) * maxFirstPage, page * maxFirstPage) ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                tableBodyData.push([
                    { "no": 1, "text": data.id, "width": "50px", "textAlign": "center" },
                    { "no": 2, "text": data.agent_name, "width": "150px", "textAlign": "left" },
                    {
                        "no": 13, "text": data.hierarchy_path
                            .filter((item) => item.auth_level === 2)
                            .map((item) => item.agent_name)[0] || '', "width": "150px", "textAlign": "left"
                    },
                    { "no": 3, "text": data.agent_id, "width": "100px", "textAlign": "center" },
                    { "no": 4, "text": Number(data.agent_fee).toFixed(2), "width": "70px", "textAlign": "center" },
                    { "no": 5, "text": data.bank_name, "width": "100px", "textAlign": "left" },
                    { "no": 6, "text": data.account_number, "width": "150px", "textAlign": "left" },
                    { "no": 7, "text": data.account_name, "width": "120px", "textAlign": "left" },
                    { "no": 8, "text": data.tax_email, "width": "150px", "textAlign": "left" },
                    { "no": 9, "text": data.reg_dt, "width": "130px", "textAlign": "center" },
                    { "no": 10, "text": data.mod_dt, "width": "130px", "textAlign": "center" },
                    // { "no": 11, "text": data.worker, "width": "70px", "textAlign": "center" },
                    ...(MyData?.role === "SUPER"
                        ? [{ "no": 12, "text": (<div className='pointer update' onClick={() => { setClickData(data); setUpdateModal(true) }}>수정</div>), "width": "70px", "textAlign": "center" }]
                        : [])
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listData, page, maxFirstPage])

    const excelBtn = () => {
        let arr = []
        if (listData) {
            for (let i = 0; i < listData.length; i++) {
                let t = listData[i]

                arr.push({
                    "NO": t.id,
                    "대리점명": t.agent_name,
                    "ID": t.agent_id,
                    "수수료": Number(t.agent_fee),
                    "정산은행": t.bank_name,
                    "계좌번호": t.account_number,
                    "예금주명": t.account_name,
                    "세금계산서이메일": t.tax_email,
                    "등록일자": t.reg_dt,
                    "변경일자": t.mod_dt,
                })
            }
        }
        Excel(arr)
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            {createModal ? <CreateInfo setModal={setCreateModal} setMessage={setMessage} setReload={setReload} /> : ""}
            {updateModal ? <UpdateInfo setModal={setUpdateModal} setMessage={setMessage} clickData={clickData} setReload={setReload} /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    {<SearchSelectText type={"검색구분"} selectData={select3} handleSelectChange={handleSelectChange2} selectedValue={selectedValue2} handleSelectTextChange={handleSelectTextChange4} selectedText={selectedText4} btnText={"검색"} onClick={() => setReload(e => !e)} />}

                    {
                        MyData?.role == "SUPER"
                            ?
                            <div class="button_wrap separate" style={{ marginTop: "0px" }}>
                                <SearchCrteateBtn type={"대리점 등록"} onClick={() => setCreateModal(true)} />
                                {/* <SearchExcelBtn type={"엑셀 다운로드"} onClick={() => excelBtn()} /> */}
                            </div>
                            :
                            ""
                    }

                </form>
                {/* <div className="more_wrap">
                    <button type="button" onClick={() => setMoreBtn(e => !e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down" data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg><span>더보기</span>
                    </button>
                </div> */}
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <CountAmountLeft tableBodyData={combineList ?? []} />
                    <div className='excel-disable'>
                        <CountSelect onChange={handleChange} maxFirstPage={maxFirstPage} />
                    </div>
                </div>

                <List tableHeaderData={tableHeaderData} tableBodyData={combineList ?? []} filter_tableBodyData={combineData} page={page} setPage={setPage} maxFirstPage={maxFirstPage} />
            </div>
        </div>
    )
}

function CreateInfo({ setModal, setMessage, setReload }) {
    const [levelData, setLevelData] = useState([])
    const [formData, setFormData] = useState({
        대리점ID: '',
        대리점명: '',
        대리점수수료: '',
        총판아이디: '',
        정산은행: '',
        계좌번호: '',
        예금주: '',
        세금계산서Email: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    useEffect(() => {
        LevelList()
    }, [])

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/agent/up-list`, {
            withCredentials: true,
            params: {
                level: 3
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setLevelData(tmp?.data?.agent ?? [])
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    // ▼ 중복 클릭 방지용 상태
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        // 이미 제출 중이면 리턴
        if (isSubmitting) return;

        // 제출 시작
        setIsSubmitting(true);

        try {
            await axios.post(process.env.REACT_APP_API + "/api/agent/regist", {
                auth_cd: 3,
                agent_id: formData.대리점ID,
                nm: formData.대리점명,
                agent_fee: formData.대리점수수료,
                parent_code: formData.총판아이디,
                bank_nm: formData.정산은행,
                accnt_no: formData.계좌번호,
                accnt_nm: formData.예금주,
                tax_email: formData.세금계산서Email,
                worker: 'admin'
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setMessage({ msg: "대리점 등록에 성공했습니다." })
                    setReload(e => !e)
                    setModal(false)
                }
                else {
                    setMessage({ msg: "대리점 등록에 실패했습니다." })
                }
            }).catch(error => {
                setMessage({ msg: "대리점 등록에 실패했습니다." })
                console.error(error);
            });
        } finally {
            // 제출 끝
            setIsSubmitting(false);
        }
    }

    return (
        <div id="distributor-modal" className="modal" tabIndex="-1" >
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto modal_title_sty">대리점 정보</h2>

                        {/* <button type="button" className="btn btn-primary" id="masking_disable" style={{ padding: "5px", marginRight: "20px" }}>입력폼 활성화</button> */}

                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4"
                                    data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                        <div id="data_wrap">
                            <input type="hidden" />
                        </div>
                    </div>
                    <form id="modal-form" className="modal-body grid grid-cols-12 gap-4 gap-y-3">
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점ID" className="form-label">대리점ID</label>
                            <input
                                id="대리점ID"
                                name="대리점ID"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.대리점ID}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점명" className="form-label">대리점명</label>
                            <input
                                id="대리점명"
                                name="대리점명"
                                type="text"
                                className="form-control input-padding"
                                maxLength="14"
                                value={formData.대리점명}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점수수료" className="form-label">대리점수수료</label>
                            <input
                                id="대리점수수료"
                                name="대리점수수료"
                                type="text"
                                className="form-control input-padding"
                                maxLength="10"
                                value={formData.대리점수수료}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="총판아이디" className="form-label">총판아이디</label>
                            <select
                                id="총판아이디"
                                name="총판아이디"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.총판아이디}
                                onChange={handleChange}
                            >
                                <option value="">총판을 선택해주세요.</option>
                                {
                                    levelData.map(function (a, i) {
                                        return (
                                            <option key={i} value={a.code}>{a.nm}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="정산은행" className="form-label">정산은행</label>
                            <select
                                id="정산은행"
                                name="정산은행"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.정산은행}
                                onChange={handleChange}
                            >
                                {
                                    bank.map(function (a, i) {
                                        return (
                                            <option key={i} value={a.name}>{a.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="계좌번호" className="form-label">계좌번호</label>
                            <input
                                id="계좌번호"
                                name="계좌번호"
                                type="text"
                                className="form-control input-padding"
                                value={formData.계좌번호}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="예금주" className="form-label">예금주</label>
                            <input
                                id="예금주"
                                name="예금주"
                                type="text"
                                className="form-control input-padding"
                                value={formData.예금주}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="세금계산서Email" className="form-label">세금계산서 Email</label>
                            <input
                                id="세금계산서Email"
                                name="세금계산서Email"
                                type="text"
                                className="form-control input-padding"
                                value={formData.세금계산서Email}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        {/* 중복 클릭 방지 */}
                        <button
                            type="button"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting}
                        >
                            등록
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => setModal(false)}
                            style={{ backgroundColor: "darkred", marginLeft: "10px", border: "none" }}
                            value="닫기"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

function UpdateInfo({ setModal, setMessage, clickData, setReload }) {
    const [levelData, setLevelData] = useState([])
    const [formData, setFormData] = useState({
        대리점ID: clickData.agent_id,
        대리점명: clickData.agent_name,
        대리점수수료: clickData.agent_fee,
        총판아이디: clickData.hierarchy_path
            .filter((item) => item.auth_level === 2)
            .map((item) => item.agent_code)[0] || '',
        정산은행: clickData.bank_name,
        계좌번호: clickData.account_number,
        예금주: clickData.account_name,
        세금계산서Email: clickData.tax_email,
    });

    // ▼ 중복 클릭 방지용 상태
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    useEffect(() => {
        LevelList()
    }, [])

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/agent/up-list`, {
            withCredentials: true,
            params: {
                level: 3
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setLevelData(tmp?.data?.agent ?? [])
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const onSubmit = async () => {
        // 이미 제출 중이면 리턴
        if (isSubmitting) return;

        if (window.confirm("수정하시겠습니까?")) {
            // 제출 시작
            setIsSubmitting(true);

            try {
                await axios.post(process.env.REACT_APP_API + "/api/agent/update", {
                    id: clickData.id,
                    auth_cd: 3,
                    agent_id: formData.대리점ID,
                    nm: formData.대리점명,
                    agent_fee: formData.대리점수수료,
                    parent_code: formData.총판아이디,
                    bank_nm: formData.정산은행,
                    accnt_no: formData.계좌번호,
                    accnt_nm: formData.예금주,
                    tax_email: formData.세금계산서Email
                }, {
                    withCredentials: true,
                }).then((response) => {
                    let tmp = response?.data
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "지사 수정에 성공했습니다." })
                        setReload(e => !e)
                        setModal(false)
                    }
                    else {
                        setMessage({ msg: "지사 수정에 실패했습니다." })
                    }
                }).catch(error => {
                    setMessage({ msg: "지사 수정에 실패했습니다." })
                    console.error(error);
                });
            } finally {
                // 제출 끝
                setIsSubmitting(false);
            }
        }
    }

    return (
        <div id="distributor-modal" className="modal" tabindex="-1" >
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto modal_title_sty">대리점 정보</h2>

                        {/* <button type="button" className="btn btn-primary" id="masking_disable" style={{ padding: "5px", marginRight: "20px" }}>입력폼 활성화</button> */}

                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                        <div id="data_wrap">
                            <input type="hidden" />
                        </div>
                    </div>
                    <form id="modal-form" className="modal-body grid grid-cols-12 gap-4 gap-y-3">
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점ID" className="form-label">대리점ID</label>
                            <input
                                id="대리점ID"
                                name="대리점ID"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.대리점ID}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점명" className="form-label">대리점명</label>
                            <input
                                id="대리점명"
                                name="대리점명"
                                type="text"
                                className="form-control input-padding"
                                maxLength="14"
                                value={formData.대리점명}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="대리점수수료" className="form-label">대리점수수료</label>
                            <input
                                id="대리점수수료"
                                name="대리점수수료"
                                type="text"
                                className="form-control input-padding"
                                maxLength="10"
                                value={formData.대리점수수료}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="총판아이디" className="form-label">총판아이디</label>
                            <select
                                id="총판아이디"
                                name="총판아이디"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.총판아이디}
                                onChange={handleChange}
                            >
                                {
                                    levelData.map(function (a, i) {
                                        return (
                                            <option key={i} value={a.code}>{a.nm}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="정산은행" className="form-label">정산은행</label>
                            <select
                                id="정산은행"
                                name="정산은행"
                                type="text"
                                className="form-control input-padding"
                                maxLength="30"
                                value={formData.정산은행}
                                onChange={handleChange}
                            >
                                {
                                    bank.map(function (a, i) {
                                        return (
                                            <option value={a.name}>{a.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="계좌번호" className="form-label">계좌번호</label>
                            <input
                                id="계좌번호"
                                name="계좌번호"
                                type="text"
                                className="form-control input-padding"
                                value={formData.계좌번호}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="예금주" className="form-label">예금주</label>
                            <input
                                id="예금주"
                                name="예금주"
                                type="text"
                                className="form-control input-padding"
                                value={formData.예금주}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="세금계산서Email" className="form-label">세금계산서 Email</label>
                            <input
                                id="세금계산서Email"
                                name="세금계산서Email"
                                type="text"
                                className="form-control input-padding"
                                value={formData.세금계산서Email}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        {/* 중복 클릭 방지 */}
                        <button
                            type="button"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={onSubmit}
                            disabled={isSubmitting} // 버튼 비활성화
                        >
                            수정
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => setModal(false)}
                            style={{ backgroundColor: "darkred", marginLeft: "10px", border: "none" }}
                            value="닫기"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `대리점리스트`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "대리점명", "ID", "수수료", "정산은행", "계좌번호", "예금주명", "세금계산서이메일", "등록일자", "변경일자"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.대리점명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.ID },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.수수료 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.정산은행 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.계좌번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.예금주명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.세금계산서이메일 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.등록일자 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.변경일자 }
                ]

            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 50 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 50 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 150 },
            { wpx: 150 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Franchise